<template>
    <div style="padding: 0 20px">
        <div class="top">
            <div>
                <el-input
                          size="small"
                          placeholder="请输入姓名"
                          suffix-icon="el-icon-search"
                          style="width: 220px;margin-right: 20px">
                </el-input>
                <el-input
                        size="small"
                        placeholder="请输入手机号"
                        suffix-icon="el-icon-search"
                        style="width: 220px;margin-right: 20px">
                </el-input>
            </div>

        </div>
        <el-table :data="tableData"
                  :header-cell-style="{'padding-left': '8%'}"
                  :cell-style="{'padding-left': '8%'}">
            <el-table-column label="代理商名称"></el-table-column>
            <el-table-column label="手机号"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="dialogEditVisible = true">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handlePageChange"
            ></el-pagination>
        </div>
        <el-dialog title="编辑角色" :visible.sync="dialogEditVisible" width="700px"
                   :close-on-click-modal="false">
            <div style="text-align: center">
                <el-transfer
                        style="text-align: left; display: inline-block"
                        v-model="overPharmacy"
                        filterable
                        filter-placeholder="搜索药房名称"
                        :titles="['共享药房', '已配置共享药房']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :data="items">
                    <span slot-scope="{ option }">{{ option.label }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="width: 76px">取消</el-button>
                <el-button type="primary" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            authorization:localStorage.getItem('authorization'),
            tableData: [{}],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            dialogEditVisible:false,
            items: [],
            overPharmacy: [],
        }
    },
    methods: {
        getData() {

        },
        // 换页
        handlePageChange(val) {
            this.pageNum = val
            this.queryRole()
        },
    }
};
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 12px;
        height: 52px;
    }
</style>